import { render, staticRenderFns } from "./AddContact.vue?vue&type=template&id=b1e27f8e&"
import script from "./AddContact.js?vue&type=script&lang=js&"
export * from "./AddContact.js?vue&type=script&lang=js&"
import style0 from "./AddContact.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports